import * as React from "react";
import { JSX } from "react/jsx-runtime";
const ExclamatoryIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.02216 9.73828L7.04337 9.73828C7.29792 9.73828 7.53125 9.52616 7.53125 9.2504C7.53125 8.97465 7.31913 8.76252 7.04337 8.76252L7.02216 8.76252C6.76761 8.76252 6.53428 8.97464 6.53428 9.2504C6.53428 9.52616 6.7464 9.73828 7.02216 9.73828Z"
      fill="#FF5E5E"
    />
    <path
      d="M7.02384 8.0625C7.27839 8.0625 7.51172 7.85038 7.51172 7.57462L7.51172 4.30795C7.51172 4.05341 7.2996 3.82008 7.02384 3.82008C6.76929 3.82008 6.53596 4.0322 6.53596 4.30795L6.53596 7.59583C6.53596 7.85038 6.74808 8.0625 7.02384 8.0625Z"
      fill="#FF5E5E"
    />
    <path
      d="M7.02195 13.4062C10.5644 13.4062 13.4492 10.5426 13.4492 7.00019C13.4492 3.45777 10.5644 0.572917 7.02195 0.572916C3.47952 0.572916 0.615887 3.45776 0.615886 7.00019C0.615886 10.5426 3.47952 13.4062 7.02195 13.4062ZM7.02195 1.52746C10.0341 1.52746 12.4947 3.98807 12.4947 7.00019C12.4947 10.0123 10.0341 12.4729 7.02195 12.4729C4.00982 12.4729 1.57043 10.0123 1.57043 7.00019C1.57043 3.98807 4.00983 1.52746 7.02195 1.52746Z"
      fill="#FF5E5E"
    />
  </svg>
);
export default ExclamatoryIcon;
